import type { ExtractPropTypes, PropType } from "vue";
import type PageHeader from "./page-header.vue";

export const PageHeaderProps = {
  title: {
    type: String,
    default: "",
  },
  underline: {
    type: Boolean,
    default: true,
  },
  slotFlex: {
    type: String as PropType<"between" | "start">,
    default: "start",
  },
  /**
   * pinia useSystemMenuStoreHook
   */
  action: Object,
};

export type PageHeaderPropsType = ExtractPropTypes<typeof PageHeaderProps>;
export type PageHeaderInstance = InstanceType<typeof PageHeader>;
